<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Student Health Remark">
        <v-card flat class="px-2">
          <form @submit.prevent="termListing">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"> Class <span class="error--text">*</span> </label>

                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--SELECT--"
                  name="classSelect"
                  required
                  v-model="selectedClassID"
                  v-on:change="changeSections(), termLists()"
                  item-value="id"
                  :items="classes"
                  key="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"> Section <span class="error--text">*</span> </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--SELECT--"
                  name="sectionSelect"
                  required
                  v-model="selectedSectionID"
                  item-value="id"
                  :items="classWiseSections"
                  key="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Select Term <span class="error--text">*</span></label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--SELECT--"
                  required
                  v-model="term"
                  :items="terms"
                  key="id"
                  item-value="id"
                  :item-text="item => item.academicTerm.name + `(${item.fromDate}) ` + `/ (${item.toDate})`"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <span class="font-weight-medium body-2">Action</span>
                <div class="inside">
                  <v-btn elevation="1" type="submit" color="success"><v-icon left>mdi-text-box-check-outline</v-icon>Apply</v-btn>
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component v-if="termList.length > 0">
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
            <v-btn v-if="isWrite && this.termList.length > 0" elevation="1" @click="saveData()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
              <v-icon left>mdi-plus</v-icon>
              Bulk Save
            </v-btn>
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
          :search.sync="search"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="termList"
          >
            <template v-slot:item.height="{ item }">
              <v-text-field :rules="textRules" max="999" :disabled="item.hightchecked === 1" v-model.trim="item.gradeStudentHealthRemark.height" type="number" placeholder="Ex. 127.4" required> </v-text-field>
            </template>
            <template v-slot:item.weight="{ item }">
              <v-text-field :rules="textRules" max="999" placeholder="Ex. 20" :disabled="item.weightchecked === 1" v-model.trim="item.gradeStudentHealthRemark.weight" type="number" required></v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">

              <span v-if="isWrite" class="d-flex justify-center">
                <v-btn outlined v-if="item.ischecked === 1" @click="saveData('single', item.id)" class="px-2 ml-1 ma-1" color="primary" min-width="0" small>
                  add Student Health Remark
                </v-btn>
                <v-btn outlined @click="editGrade(item.gradeStudentHealthRemark.id)" v-if="item.ischecked !== 1" class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  Edit Student Health Remark
                </v-btn>
              </span>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <v-dialog persistent v-model="enableRemarkModal" max-width="650">
        <form @submit.prevent="EditSave">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Edit Student Health Remark</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggleRemarkModal, clearEditRemark()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :rules="textRules" max="999" label="Height" required v-model="hight" type="number"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field :rules="textRules" max="999" label="Weight" required v-model="weight" type="number"> </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
    <!-- Edit Student Health remark -->
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import Utils from '@/utils'
import moment from 'moment'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'studentHealthRemark',
  components: { MaterialCard, VCardComponent },
  data () {
    return {
      isLoading: true,
      total: 0,
      termList: [],
      isWrite: false,
      term: '',
      search: '',
      dialog: false,
      terms: [],
      height: '',
      weight: '',
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      selectedStudent: '',
      hight: '',
      academicYears: [],
      selectedClassID: '',
      academicTermDateMapid: '',
      selectedSectionID: '',
      enableRemarkModal: false,
      classID: '',
      classWiseSections: [],
      classes: [],
      tempArray: [],
      gradeStudentHealthRemarkID: '',
      goLoop: true,
      headers: [
        { text: 'Enrollment Code', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'Student Name', value: 'studentEnrollment.studentName', sortable: true },
        { text: 'Height (in Cms)', value: 'height', sortable: false },
        { text: 'Weight (in Kg)', value: 'weight', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      textRules: [
        v => (v && v < 999) || 'Value shoul be less than 999'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    termListing: async function () {
      this.isLoading = true
      const { data } = await http.get(`${constants.API_URL}/api/grade-module/health-remark`, {
        params: { franchiseeID: this.franchiseeID, academicYearID: this.academicYearID, classID: this.selectedClassID, sectionID: this.selectedSectionID, academicTermsDateMapID: this.term }
      })
      this.termList = data
      let r = this.termList.map(a => {
        if (!a.gradeStudentHealthRemark) {
          a.ischecked = 1
          a.gradeStudentHealthRemark = {
            height: null,
            weight: null
          }
        }
        if (a.gradeStudentHealthRemark.height != null) {
          a.hightchecked = 1
        }
        if (a.gradeStudentHealthRemark.weight != null) {
          a.weightchecked = 1
        }
        return a
      })
      this.termList = r
      if (this.termList.length === 0) {
        this.$dialog.error({
          title: 'Error',
          text: 'No Data Found'
        })
      }
      this.total = this.termList.length
      this.isLoading = false
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID && this.academicYearID) {
          await this.getClassList()
        }
        this.selectedClassID = ''
        this.selectedSectionID = ''
        this.clearClass()
        this.inProgress = false
      }
    },
    termLists: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select franchisee!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select academic year!')
        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select class!')
        return false
      }
      this.term = ''
      this.terms = []
      this.termList = ''
      try {
        const Terms = await http.get(`${constants.API_URL}/api/grade-module/academic-terms/date/map`, {
          params: { franchiseeID: this.franchiseeID, academicYearID: this.academicYearID, classID: this.selectedClassID }
        })
        if (Terms.data.length === 0) {
          this.$dialog.message.warning('Academic Term Not Found With Selected Class , Academic Year And Franchisee', {
            position: 'top',
            timeout: 6000
          })
        } else {
          this.terms = Terms.data
          let x = this.terms.map(a => {
            a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
            return a
          })
          let y = this.terms.map(b => {
            b.toDate = moment(b.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
            return b
          })
          this.terms = x
          this.terms = y
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        this.classes = []
        const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=false`)
        if (data) {
          this.classes = data
          this.sections = data.map(obj => {
            return {
              id: obj.id,
              sections: obj.studentSections
            }
          })
        }
        await this.getFranchiseeList()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    changeSections: async function () {
      this.selectedSectionID = ''
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = 0
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    editGrade: async function (ID) {
      this.gradeStudentHealthRemarkID = ID
      try {
        let { data } = await http.get(`${constants.API_URL}/api/grade-module/health-remark/${this.gradeStudentHealthRemarkID}`)
        this.hight = data[0].gradeStudentHealthRemark.height
        this.weight = data[0].gradeStudentHealthRemark.weight
        this.toggleRemarkModal()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    EditSave: async function () {
      this.hasClicked = true
      let HealthData = {
        height: this.hight,
        weight: this.weight
      }
      try {
        await http.put(`${constants.API_URL}/api/grade-module/health-remark/${this.gradeStudentHealthRemarkID}`, HealthData)
        this.clearEditRemark()
        this.termListing()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    toggleRemarkModal: function () {
      this.enableRemarkModal = !this.enableRemarkModal
    },
    clearEditRemark: function () {
      this.gReamark = ''
      this.bReamark = ''
      this.academicTermDateMapid = ''
      this.enableRemarkModal = !this.enableRemarkModal
    },
    clearClass: function () {
      this.terms = []
      this.term = ''
      this.termList = ''
      this.selectedClassID = ''
      this.selectedSectionID = ''
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    saveData: async function (isSingle, idGot) {
      let index = parseInt(_.map(this.termList, (a, i) => a.id === idGot ? i : false).filter(a => a !== false).toString())

      if (isSingle === 'single') {
        let r = this.termList.some((a, i) => {
          if (this.goLoop && index === i) {
            if (a.gradeStudentHealthRemark.height > 999 || a.gradeStudentHealthRemark.weight > 999) {
              this.errMsg('Height and Weight cannot be greated than 999!')
              this.goLoop = false
              return false
            }

            if (!a.gradeStudentHealthRemark.height) {
              this.errMsg('Height cannot be empty!')
              this.goLoop = false
              return false
            } else if (!a.gradeStudentHealthRemark.weight) {
              this.errMsg('Weight cannot be empty!')
              this.goLoop = false
              return false
            } else {
              return true
            }
          }
        })
        if (!r) {
          this.goLoop = true
          return false
        }
      } else {
        let r = this.termList.map(a => {
          if (this.goLoop) {
            if (a.gradeStudentHealthRemark.height > 999 || a.gradeStudentHealthRemark.weight > 999) {
              this.errMsg('Height and Weight cannot be greated than 999!')
              this.goLoop = false
              return false
            }

            if (!a.gradeStudentHealthRemark.height) {
              this.errMsg('Height value for one or more row is empty!')
              this.goLoop = false
              return false
            } else if (!a.gradeStudentHealthRemark.weight) {
              this.errMsg('Weight value for one or more row is empty!')
              this.goLoop = false
              return false
            } else {
              return true
            }
          }
        })
        let res = r.some(c => c === false)
        if (res) {
          this.goLoop = true
          return false
        }
      }
      this.termList.map(a => {
        if (a.gradeStudentHealthRemark.height !== null && a.gradeStudentHealthRemark.weight === null) {
          this.tempArray.push({
            studentAdmissionsID: a.id,
            height: a.gradeStudentHealthRemark.height
          })
        }

        if (a.gradeStudentHealthRemark.height === null && a.gradeStudentHealthRemark.weight !== null) {
          this.tempArray.push({
            studentAdmissionsID: a.id,
            weight: a.gradeStudentHealthRemark.weight
          })
        }
        if (a.gradeStudentHealthRemark.height !== null && a.gradeStudentHealthRemark.weight !== null) {
          this.tempArray.push({
            studentAdmissionsID: a.id,
            height: a.gradeStudentHealthRemark.height,
            weight: a.gradeStudentHealthRemark.weight
          })
        }
      })
      let formData = {
        academicYearID: this.academicYearID,
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        sectionID: this.selectedSectionID,
        academicTermsDateMapID: this.term,
        gradeHealthMaps: this.tempArray
      }

      try {
        this.isLoading = true
        await http.post(`${constants.API_URL}/api/grade-module/health-remark`, formData)
        this.loader = false
        this.termListing()
        this.tempArray = []
        this.isLoading = false
        return this.$dialog.info({
          title: 'Success',
          text: 'Saved successfully'
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
  }
}
</script>
